import { render, staticRenderFns } from "./objectStageSetEdit.vue?vue&type=template&id=2a1b3b3f"
import script from "./objectStageSetEdit.vue?vue&type=script&lang=js"
export * from "./objectStageSetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a1b3b3f')) {
      api.createRecord('2a1b3b3f', component.options)
    } else {
      api.reload('2a1b3b3f', component.options)
    }
    module.hot.accept("./objectStageSetEdit.vue?vue&type=template&id=2a1b3b3f", function () {
      api.rerender('2a1b3b3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/objectStageSetEdit.vue"
export default component.exports